import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { UiProvider } from './contexts/UiContext';
import { ActiveTenantProvider } from './hooks/useActiveTenant';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <UiProvider>
          <AuthProvider>
            <ActiveTenantProvider>
              <div className="App">
                <AppRoutes />
              </div>
            </ActiveTenantProvider>
          </AuthProvider>
        </UiProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
